import React, {Component} from 'react';
import Slider from 'react-slick';
// import {connect} from 'react-redux';
// import {Link} from 'gatsby'
// import {getBestSeller} from "../../services";
// import {addToCart, addToWishlist, addToCompare} from "../../actions";
import ProductItem from '../collection-settings/product-list-item'

class RelatedProduct extends Component {
    render (){
        // const {items, symbol, addToCart, addToWishlist, addToCompare} = this.props;
        
        var productsnav = {
            infinite: true,
            // speed: 3000,
            slidesToShow: 6,
            slidesToScroll: 2,
            dots: true,
            autoplay: true,
            // autoplaySpeed: 3000,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow:3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 420,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };

        return (
            <section className="section-b-space">
                <div className="container">
                    <div className="row">
                        <div className="col-12 product-related">
                            <h2>related products</h2>
                        </div>
                    </div>
                    <div className="row search-product">
                        <div className="col">
                            <Slider {...productsnav}>
                                { this.props.products.map(({node}, index ) =>
                                    <div key={index} className="pr-sm-2">
                                        <ProductItem product={node} key={index} />
                                        {/* symbol={symbol}
                                                    onAddToCompareClicked={() => addToCompare(product)}
                                                    onAddToWishlistClicked={() => addToWishlist(product)}
                                                    onAddToCartClicked={() => addToCart(product, 1)} */}
                                    </div>)
                                }
                            </Slider>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

// function mapStateToProps(state) {
//     return {
//         items: getBestSeller(state.data.products),
//         symbol: state.data.symbol
//     }
// }

// export default connect(mapStateToProps, {addToCart, addToWishlist, addToCompare})(RelatedProduct);

export default RelatedProduct